const form = {
  formId: "new-client-form",
  formField: {
    name: {
      name: "name",
      label: "اسم العميل",
      type: "text",
      errorMsg: "اسم العميل مطلوب.",
    },
    id: {
      name: "id",
      label: "رقم العميل",
      type: "text",
      errorMsg: "رقم العميل مطلوب.",
    },
  },
};

export default form;
